import React from "react";

interface PageHeaderProps {
  title: string;
  subtitle?: string;
}

const PageHeader = ({ title, subtitle }: PageHeaderProps) => {
  return (
    <div className="my-14">
      <h2 className="font-semibold mb-10 text-2xl md:text-4xl text-center font-[poppins]">
        {" "}
        {title}
      </h2>
      <p className=" text-center text-lg  text-gray-500">{subtitle}</p>
    </div>
  );
};

export default PageHeader;
